export type Testimonial = {
  quote: string;
  name: string;
  role: string;
};
export type MapBlock = {
  icon: 'book' | 'scroll';
  title: string;
  description: string;
};
export type Bonus = {
  label: string;
  title: string;
  subtitle: string;
  description: string;
  value: string;
  image: string;
};
export type Faq = {
  question: string;
  answer: string;
};
export type MapSlide = {
  book: string;
  block: string;
  image: string;
};
export type BlockChip = {
  label: string;
  books: string;
  color: string;
};
export type VerifiedPurchase = {
  name: string;
  city: string;
  time: string;
};
export const checkoutUrl = 'https://gps-biblico-arg.impultienda.ar/checkout';
export const launchOffer = {
  regularPrice: '$49.990',
  price: '$14.990',
  saveLabel: 'Ahorrás $35.000',
  note: 'Llevate GPS Bíblico + todos los bonos',
  detail: 'Accedé a los 73 mapas visuales y a los 5 bonos con un pago único. Sin suscripciones ni cargos mensuales.',
  totalValue: '$121.990',
  totalLead: 'Llevate todo hoy por',
  totalSaveLabel: 'Ahorrás $107.000',
  paymentNote: '🔒 Pago seguro con Mercado Pago o tarjeta'
};
export const cta = {
  label: 'SÍ, QUIERO MI GPS BÍBLICO →',
  short: 'QUIERO MI GPS BÍBLICO →',
  hero: 'QUIERO CONOCER GPS BÍBLICO →',
  microcopy: 'Pago único de $14.990 · Sin suscripciones',
  heroMicrocopy: 'Material digital en PDF · Para celular, tablet o computadora',
  finalMicrocopy: 'Pago único · Acceso digital · 7 días de garantía'
};
export const hero = {
  eyebrow: '🙏 GPS Bíblico™ — Material católico',
  titleStart: 'Entendé los 73 libros de la Biblia Católica',
  titleHighlight: 'de forma visual, clara y ordenada',
  subtitle: 'GPS Bíblico reúne 73 mapas visuales, uno por cada libro, para ayudarte a comprender qué estás leyendo, su contexto, su estructura y su mensaje central.',
  offerLine: '73 mapas visuales · De Génesis a Apocalipsis',
  imageIntro: 'Así se ve una de las guías visuales incluidas en GPS Bíblico:'
};
export const heroImage = 'https://cdn.magicpatterns.com/uploads/pyTyceds7QUKNgubztkX1F/Imagen_de_ChatGPT_26_sept_2026,_01_04_02_p.m..png';
export const heroImageAlt = 'Pack completo de GPS Bíblico: el cuaderno principal con los mapas de Génesis, Sabiduría y Mateo, y los bonos Diccionario Visual Bíblico Express, Guía de Símbolos Bíblicos Esenciales, 7 Días para Entender Mejor la Biblia, Guía de Navegación Visual y Ruta Bíblica 365';
export const offerHighlights = ['Acceso digital al confirmar', 'Material en PDF', 'Celular, tablet o computadora', '7 días de garantía'];
export const trustStats = [{
  value: '73',
  label: 'libros mapeados'
}, {
  value: '2.000+',
  label: 'católicos lo usan'
}, {
  value: "6",
  label: 'bonos incluidos'
}, {
  value: '4.9/5',
  label: 'calificación'
}];
export type OfferItem = {
  title: string;
  description: string;
  value: string;
  free: boolean;
};
export const offerStack = {
  title: 'Todo lo que recibís hoy',
  image: 'https://cdn.magicpatterns.com/uploads/13RiNJ6q9BSBuktgfYPPD8/Imagen_de_ChatGPT_26_sept_2026,_01_30_32_p.m..png',
  items: [{
    title: 'GPS Bíblico — 73 Mapas Visuales',
    description: 'uno por cada libro, de Génesis a Apocalipsis',
    value: '$49.990',
    free: false
  }, {
    title: 'Guía de Navegación Visual',
    description: 'cómo usar cada mapa desde el primer día',
    value: '$17.000',
    free: true
  }, {
    title: 'Ruta Bíblica 365',
    description: 'un plan de lectura para todo el año',
    value: '$16.000',
    free: true
  }, {
    title: '7 Días para Entender Mejor la Biblia',
    description: 'un recorrido breve para empezar esta semana',
    value: '$12.000',
    free: true
  }, {
    title: 'Guía de Símbolos Bíblicos Esenciales',
    description: 'agua, luz, fuego, pan, cordero, templo y más',
    value: '$14.000',
    free: true
  }, {
    title: 'Diccionario Visual Bíblico Express',
    description: 'las palabras que frenan tu lectura, explicadas',
    value: '$13.000',
    free: true
  }] as OfferItem[]
};
export const painHeadline = '¿Alguna vez abriste la Biblia con ganas de entenderla… pero terminaste sintiéndote perdido?';
export const painIntro = 'Podés leer las palabras y aun así preguntarte:';
export const painClaim = 'No es falta de fe. Es falta de una ruta.';
export const painClose = 'GPS Bíblico ordena cada libro en un mapa visual para que sepas qué estás leyendo.';
export const painPoints = ['¿Qué está pasando en este libro?', '¿Quién lo escribió?', '¿En qué momento de la historia bíblica estoy?', '¿Cuál es el mensaje principal?', '¿Cómo se conecta con el resto de la Biblia?'];
export const systemAnswers = [{
  letter: 'G',
  label: 'Guía',
  description: "Ubicá el libro: quién lo escribió, en qué contexto y a qué grupo bíblico pertenece."
}, {
  letter: 'P',
  label: 'Propósito',
  description: "Descubrí para qué fue escrito y cuál es su mensaje central, en una sola vista."
}, {
  letter: 'S',
  label: 'Sabiduría práctica',
  description: "Entendé qué significa lo que leés y cómo aplicarlo hoy, en tu vida y en tu oración."
}];
export const mainProduct = {
  title: 'Así se ve GPS Bíblico por dentro',
  description: 'Una hoja por cada uno de los 73 libros. Consultala antes o durante la lectura para tener una visión general y saber qué buscar en el texto.'
};
export const mapSlides: MapSlide[] = [{
  book: 'Génesis',
  block: 'Pentateuco · Antiguo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/8c1UvMpXhtHB4UxBEXj53X/Captura_de_pantalla_2026-09-13_202538.png'
}, {
  book: 'Ester',
  block: 'Libros Históricos · Antiguo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/fQ4LHNjLSDWHob2mgDqdHy/Captura_de_pantalla_2026-09-13_202609.png'
}, {
  book: 'Proverbios',
  block: 'Poéticos y Sapienciales · Antiguo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/cAhF5jV7TndHx14oYDPHZP/Captura_de_pantalla_2026-09-13_202630.png'
}, {
  book: 'Sabiduría',
  block: 'Poéticos y Sapienciales · Antiguo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/nay79ctEaokAyg3dckWgUR/Captura_de_pantalla_2026-09-13_202649.png'
}, {
  book: 'Mateo',
  block: 'Evangelios · Nuevo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/87xhcHM2Y4ZiaqwViww2dY/Captura_de_pantalla_2026-09-13_202446.png'
}, {
  book: '2 Corintios',
  block: 'Cartas Paulinas · Nuevo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/qBxu1fQQvYyV7yjygWNNcL/Captura_de_pantalla_2026-09-13_202710.png'
}, {
  book: 'Apocalipsis',
  block: 'Profético · Nuevo Testamento',
  image: 'https://cdn.magicpatterns.com/uploads/wC3HRCf8xp4q32Pz4AHcex/Captura_de_pantalla_2026-09-13_202730.png'
}];
export const testimonialImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/gcVv1p2mVZiXJpLin8zeqM/Imagen_de_ChatGPT_26_sept_2026,_01_59_24_p.m..png',
  alt: 'Reseñas de Ramon Nicolas Ramos, Naty Muñoz y Lucas Almaraz recomendando Tu Conexión Educativa'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2uvKGCnQP6dDicqmHhXh7W/Imagen_de_ChatGPT_26_sept_2026,_01_59_27_p.m..png',
  alt: 'Reseñas de Mariana González, Rocio Baldevenito Torres y Clarisa Sandoval recomendando Tu Conexión Educativa'
}];
export const mapAnatomy = {
  title: 'Cada mapa responde las 8 preguntas clave de cada libro',
  description: 'Qué enseña, quién lo escribió y en qué contexto, para qué fue escrito, a qué grupo pertenece, cómo está organizado, cómo aplicarlo, su mensaje central y por qué es importante.',
  image: 'https://cdn.magicpatterns.com/uploads/xaNMrS7pU5SybtBQhFPnr4/Imagen_de_ChatGPT_26_sept_2026,_01_19_04_p.m..png',
  imageAlt: 'Mapa mental de Génesis con sus 8 preguntas clave: qué enseña este libro, autor y contexto, para qué fue escrito, a qué grupo pertenece, cómo está organizado, qué significa y cómo aplicarlo, el mensaje central resumido y por qué es importante'
};
export const mapFeatures = [{
  title: '¿Quién lo escribió?',
  description: 'El autor del libro y el contexto en el que fue escrito.'
}, {
  title: 'A qué grupo pertenece',
  description: 'El bloque al que corresponde, por ejemplo Pentateuco, y cuántos libros lo integran.'
}, {
  title: 'Propósito',
  description: 'Para qué fue escrito y qué venía a responder en su momento.'
}, {
  title: 'Temas principales',
  description: 'Las ideas centrales que enseña ese libro.'
}, {
  title: 'Estructura del libro',
  description: 'Cómo está organizado internamente, para no perderte al leer.'
}, {
  title: 'Interpretación',
  description: "Qué significa lo que leés y cómo aplicarlo a tu vida de fe hoy."
}, {
  title: 'Mensaje central',
  description: 'El mensaje principal del libro, resumido.'
}, {
  title: 'Importancia',
  description: 'Por qué es importante y cómo se conecta con el resto de la Biblia.'
}];
export const mapBlocks: MapBlock[] = [{
  icon: 'book',
  title: 'Antiguo Testamento · 46 mapas',
  description: 'Pentateuco, Históricos, Poéticos y Sapienciales, y Proféticos. Cada mapa indica su grupo para que siempre sepas en qué parte de la Biblia estás.'
}, {
  icon: 'scroll',
  title: 'Nuevo Testamento · 27 mapas',
  description: 'Evangelios, Hechos, Cartas Paulinas, Cartas Generales y Apocalipsis. Cada mapa te ayuda a ver cómo se conecta con la historia bíblica.'
}];
export const blockChips: BlockChip[] = [{
  label: 'Pentateuco',
  books: '5 libros',
  color: '#4aa3c7'
}, {
  label: 'Históricos',
  books: '16 libros',
  color: '#5aa36b'
}, {
  label: 'Sapienciales',
  books: '7 libros',
  color: '#c08c33'
}, {
  label: 'Proféticos',
  books: '18 libros',
  color: '#8f6fc0'
}, {
  label: 'Evangelios',
  books: '4 libros',
  color: '#c97a3c'
}, {
  label: 'Hechos y Cartas',
  books: '22 libros',
  color: '#b4544a'
}, {
  label: 'Apocalipsis',
  books: '1 libro',
  color: '#6b7890'
}];
export const bonuses: Bonus[] = [{
  label: 'Bono #1',
  title: 'Guía de Navegación Visual',
  subtitle: 'Para usar los mapas desde el primer día.',
  description: 'Qué mirar primero en cada hoja, qué preguntas hacerte al abrir un libro y cómo conectar unos con otros.',
  value: '$17.000',
  image: 'https://cdn.magicpatterns.com/uploads/wiBvPGMTkzfeVnSRRDxmNy/heylloyd-image-1789329039469.png'
}, {
  label: 'Bono #2',
  title: 'Ruta Bíblica 365',
  subtitle: 'Para quien empezó varias veces y no pudo seguir.',
  description: "Un plan de lectura anual con orden y casilleros para ir marcando cada libro que leés.",
  value: '$16.000',
  image: 'https://cdn.magicpatterns.com/uploads/giw2qFbGDGbawJFytUBzDx/heylloyd-image-1789330570864.png'
}, {
  label: 'Bono #3',
  title: '7 Días para Entender Mejor la Biblia',
  subtitle: 'Para empezar esta misma semana.',
  description: 'Un recorrido de siete días: panorama general, Antiguo Testamento, Evangelios, cartas y Apocalipsis.',
  value: '$12.000',
  image: 'https://cdn.magicpatterns.com/uploads/nAqxsbJGL1928FNgPBm7nu/heylloyd-image-1789567901572.png'
}, {
  label: 'Bono #4',
  title: 'Guía de Símbolos Bíblicos Esenciales',
  subtitle: 'Para comprender el lenguaje simbólico.',
  description: 'Agua, luz, fuego, pan, desierto, monte, cordero, pastor, viña y templo: qué significan y dónde aparecen.',
  value: '$14.000',
  image: 'https://cdn.magicpatterns.com/uploads/j7GXio7hKxmRtsELZUoKB2/heylloyd-image-1789570588006.png'
}, {
  label: 'Bono #5',
  title: 'Diccionario Visual Bíblico Express',
  subtitle: 'Para cuando una palabra frena tu lectura.',
  description: 'Alianza, reino, gracia, profeta, evangelio, apóstol y más, explicados en pocas líneas y con ejemplos.',
  value: '$13.000',
  image: 'https://cdn.magicpatterns.com/uploads/dwPBKZPd5qAhHAVgjukoAF/heylloyd-image-1789514416109.png'
}];
export const bonusesTotal = '$72.000';
export const forYou = ['Sos católico y querés entender lo que leés, no solo leer más', 'Sos catequista, coordinador o líder de un grupo bíblico', 'Abrís la Biblia y no sabés por dónde empezar', 'Ya leés, pero te perdés entre nombres, épocas y contextos', 'Querés leer en familia y que los chicos también entiendan'];
export const notForYou = ['Buscás un comentario académico versículo por versículo', 'Esperás un curso en video con clases semanales', 'Buscás algo que reemplace la lectura de la Biblia'];
export const priceIncludesTitle = 'Comprá con tranquilidad';
export const priceIncludes = ['73 mapas visuales en PDF (46 AT + 27 NT)', 'Los 5 bonos digitales incluidos', 'Pago seguro con Mercado Pago o tarjeta', 'Acceso digital después de confirmar la compra', 'Podés utilizarlo desde celular, tablet o computadora', '7 días de garantía'];
export const guarantee = {
  title: 'Probalo durante 7 días sin riesgo',
  body: 'Tenés 7 días desde tu compra para conocer GPS Bíblico. Si dentro de ese período sentís que el material no es para vos, podés solicitar la devolución de tu dinero.',
  claim: 'Queremos que compres con total tranquilidad.'
};
export const featuredTestimonials: Testimonial[] = [{
  quote: 'Doy catequesis hace seis años y siempre explicaba los profetas como podía. Ahora llevo la hoja del libro que toca y los chicos entienden el contexto en tres minutos.',
  name: 'María G.',
  role: 'Catequista · Ciudad de México'
}, {
  quote: 'Coordino un grupo bíblico de doce personas. Antes preparaba cada encuentro dos horas; ahora leo el mapa del libro y guío la conversación sin miedo a equivocarme.',
  name: 'Carlos L.',
  role: 'Líder de grupo bíblico · Bogotá'
}];
export const testimonials: Testimonial[] = [{
  quote: 'Nunca había leído la Biblia entera. Empecé con la hoja de Génesis, entendí de qué se trataba antes de abrirla y por primera vez seguí hasta el final del libro.',
  name: 'Javier P.',
  role: 'Principiante · Madrid'
}, {
  quote: 'Mis hijos preguntan todo y yo no sabía qué contestar. Con los mapas puedo explicarles quién era cada personaje y en qué momento de la historia aparece.',
  name: 'Analía M.',
  role: 'Lectura en familia · Lima'
}, {
  quote: 'Abandoné tres planes de lectura anuales. Con la Ruta Bíblica 365 llevo cuatro meses sin saltarme un día, porque cada libro que abro ya tiene su contexto.',
  name: 'Roberto F.',
  role: 'Lectura personal · Buenos Aires'
}, {
  quote: 'Soy diácono y lo uso para preparar homilías. Ubicar la lectura del domingo dentro de la Historia de la Salvación me ahorra horas de estudio.',
  name: 'Andrés T.',
  role: 'Diácono permanente · Santiago'
}, {
  quote: 'Lo imprimimos para el grupo de la parroquia. Es el primer material católico que encontramos que explica los 73 libros de forma visual y clara.',
  name: 'Gabriela S.',
  role: 'Grupo parroquial · Guayaquil'
}, {
  quote: 'Me trababa con los profetas mayores y menores. Ahora sé quién habla, en qué época y contra qué está protestando antes de leer el primer capítulo.',
  name: 'Miguel Á.',
  role: 'Lectura personal · Monterrey'
}];
export const faqs: Faq[] = [{
  question: '¿Incluye los 73 libros?',
  answer: 'Sí. GPS Bíblico incluye un mapa visual para cada uno de los 73 libros de la Biblia Católica: 46 del Antiguo Testamento y 27 del Nuevo Testamento, incluidos los deuterocanónicos.'
}, {
  question: '¿Es un curso?',
  answer: 'No. No hay clases, videos ni horarios. Es material digital en PDF que acompaña tu lectura: consultás el mapa del libro y después abrís tu Biblia. No la reemplaza, te ayuda a comprenderla.'
}, {
  question: '¿Necesito saber mucho de Biblia?',
  answer: 'No. Está pensado tanto para quien recién empieza como para quien ya lee hace años. La Guía de Navegación Visual te explica paso a paso cómo usar cada mapa.'
}, {
  question: '¿Puedo verlo desde el celular?',
  answer: 'Sí. Podés usar los PDF desde tu celular, tablet o computadora, y guardarlos en tu dispositivo para consultarlos cuando quieras.'
}, {
  question: '¿Puedo imprimirlo?',
  answer: 'Sí. Los mapas se pueden imprimir en casa o en una imprenta, hoja por hoja o completos, para usarlos en tu estudio personal o en tu grupo.'
}, {
  question: '¿Cómo recibo el acceso?',
  answer: 'Es un producto 100% digital, no hay envío físico. Después de confirmarse tu compra, recibís el acceso al material en PDF y podés empezar a usarlo.'
}, {
  question: '¿Cómo puedo pagar?',
  answer: 'Podés pagar de forma segura con Mercado Pago o con tarjeta. Es un pago único, sin suscripciones.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. Tenés 7 días desde tu compra para conocer GPS Bíblico. Si dentro de ese período sentís que el material no es para vos, podés solicitar la devolución de tu dinero.'
}];
export const verifiedPurchases: VerifiedPurchase[] = [{
  name: 'Andrea V.',
  city: 'Córdoba',
  time: 'hace 2 minutos'
}, {
  name: 'Gustavo R.',
  city: 'Rosario',
  time: 'hace 11 minutos'
}, {
  name: 'Lucía F.',
  city: 'Mendoza',
  time: 'hace 24 minutos'
}, {
  name: 'Miguel Á.',
  city: 'La Plata',
  time: 'hace 38 minutos'
}, {
  name: 'Carmen D.',
  city: 'San Miguel de Tucumán',
  time: 'hace 52 minutos'
}, {
  name: 'José M.',
  city: 'Mar del Plata',
  time: 'hace 1 hora'
}];